import React, { useEffect, useRef, useState } from "react";
import "../../css_files/Admin/AddRoles.css";
import CloseForm from "../Master/CloseForm";
import axios from "axios";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import axiosInstance from "../../api";

function AddRoles({ setshowaddroleform, refresh, setrefresh }) {
  const [rolesdata, setrolesdata] = useState({
    Role: "",
    Head: "",
    SubHeads: [],
  });

  function handlesubmit(e) {
    e.preventDefault();
    axiosInstance
      .post(`${process.env.REACT_APP_API_URL}/api/Permissions`, rolesdata)
      .then((res) => {
        toast.success(res.data, {
          position: "bottom-center",
          theme: "dark",
        });
        setrefresh(!refresh);
        setshowaddroleform(false);
      })
      .catch((err) => {
        toast.error(err.response.data.error, {
          position: "bottom-center",
          theme: "dark",
        });
      });
  }

  return (
    <section
      style={{
        gridTemplateColumns:
          rolesdata.SubHeads.length === 0 ? "1fr" : "1fr 1fr",
      }}
      className="add-roles"
    >
      <div
        style={{
          height: "fit-content",
          width: rolesdata.SubHeads.length === 0 ? "40%" : "100%",
        }}
      >
        <form onSubmit={handlesubmit}>
          <h1>Create Role</h1>

          <blockquote>
            <label>Role Name</label>
            <select
              required
              onChange={(e) =>
                setrolesdata({ ...rolesdata, Role: e.target.value })
              }
            >
              <option value="">Select Role Name</option>
              <option value="Service-Co-Ordinator">Service-Co-Ordinator</option>
              <option value="Store Manager">Store Manager</option>
              <option value="Purchase Manager">Purchase Manager</option>
              <option value="Technician">Technician</option>
              <option value="Accounts">Accounts</option>
            </select>
          </blockquote>

          <blockquote>
            <label>Select Head</label>
            <select
              required
              onChange={(e) =>
                setrolesdata({ ...rolesdata, Head: e.target.value })
              }
            >
              <option value="">Select Head</option>
              <option value="Master">Master</option>
              <option value="Operations">Operations</option>
            </select>
          </blockquote>

          {rolesdata.Head === "Master" && (
            <blockquote>
              <label>Select Sub Head</label>
              <aside>
                {[
                  "Category",
                  "Sub-Category",
                  "HSN",
                  "Unit",
                  "Packing",
                  "Currency",
                  "GST",
                  "Parts",
                  "Boiler",
                  "Boiler Series",
                  "Boiler Series Parts Mapping",
                  "Courier",
                  "Customer",
                  "Customer Pricing",
                  "Technician",
                ].map((subheadKey) => (
                  <mark key={subheadKey}>
                    <input
                      type="checkbox"
                      checked={rolesdata.SubHeads.some((item) =>
                        Object.keys(item).includes(subheadKey)
                      )}
                      onChange={(e) => {
                        if (e.target.checked) {
                          setrolesdata({
                            ...rolesdata,
                            SubHeads: [
                              ...rolesdata.SubHeads,
                              { [subheadKey]: {} },
                            ],
                          });
                        } else {
                          setrolesdata({
                            ...rolesdata,
                            SubHeads: rolesdata.SubHeads.filter(
                              (item) => !Object.keys(item).includes(subheadKey)
                            ),
                          });
                        }
                      }}
                    />
                    {subheadKey}
                  </mark>
                ))}
              </aside>
            </blockquote>
          )}
          {rolesdata.Head === "Operations" && (
            <blockquote>
              <label>Select Sub Head</label>
              <aside>
                {["Enquiry", "Ticket", "Quotation", "Order", "Invoice"].map(
                  (subheadKey) => (
                    <mark key={subheadKey}>
                      <input
                        type="checkbox"
                        checked={rolesdata.SubHeads.some((item) =>
                          Object.keys(item).includes(subheadKey)
                        )}
                        onChange={(e) => {
                          if (e.target.checked) {
                            setrolesdata({
                              ...rolesdata,
                              SubHeads: [
                                ...rolesdata.SubHeads,
                                { [subheadKey]: {} },
                              ],
                            });
                          } else {
                            setrolesdata({
                              ...rolesdata,
                              SubHeads: rolesdata.SubHeads.filter(
                                (item) =>
                                  !Object.keys(item).includes(subheadKey)
                              ),
                            });
                          }
                        }}
                      />
                      {subheadKey}
                    </mark>
                  )
                )}
              </aside>
            </blockquote>
          )}
          <blockquote
            style={{
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            <button type="submit">Submit</button>
            {rolesdata.SubHeads.length > 0 && (
              <button
                type="button"
                onClick={() => {
                  setrolesdata({ ...rolesdata, SubHeads: [] });
                }}
              >
                Clear
              </button>
            )}
          </blockquote>
        </form>

        <CloseForm close={setshowaddroleform} />
      </div>
      {rolesdata.SubHeads.length > 0 && (
        <div
          className="add-roles"
          style={{ overflowY: "auto", maxHeight: "70vh", width: "100%" }}
        >
          {rolesdata.SubHeads.map((subhead) => (
            <blockquote style={{ marginTop: "1rem" }}>
              <label>Select Actions for {Object.keys(subhead)[0]}</label>
              <aside>
                {["Read", "Write", "Update", "Delete"].map((action) => (
                  <mark key={action}>
                    <input
                      type="checkbox"
                      onChange={(e) => {
                        setrolesdata((prev) => ({
                          ...prev,
                          SubHeads: prev.SubHeads.map((item) => {
                            const key = Object.keys(item)[0];
                            if (key === Object.keys(subhead)[0]) {
                              const existing = item[key] ?? {};
                              return {
                                [key]: {
                                  ...existing,
                                  [action]: e.target.checked,
                                },
                              };
                            }

                            return item;
                          }),
                        }));
                      }}
                    />
                    {action}
                  </mark>
                ))}
              </aside>
            </blockquote>
          ))}
        </div>
      )}
    </section>
  );
}

export default AddRoles;
